// extracted by mini-css-extract-plugin
export var alertCards = "_4-0";
export var card = "_4-1";
export var fade = "_4-2";
export var hidden = "_4-3";
export var progressBar = "_4-4";
export var roundtime = "_4-5";